import React, { useState } from 'react'
import withScrolling from 'frontend-collective-react-dnd-scrollzone'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { ScrollPositionContext, ShowOverlayProps } from './context'
import { useBotPrimaryColor } from '../../store/flow'

import { actions as scrollAction } from '../../store/scrollContainer/scrollContainerSlice'
import { useUpdateScrollbarPresenceFlag } from './useUpdateScrollbarPresenceFlag'
import { getScrollContainerElement } from '../../lib/dom'
import { currentBotMetadataSelector } from '../../features/serverBots/selectors/currentBotMetadataSelector'
import { botMetadataForEnvironmentGroupSelector } from '../../features/serverBots/selectors/botMetadataForEnvironmentGroupSelector'

const DivWithoutPropagatingDragDropManager = React.forwardRef(
  function DivWithoutPropagatingDragDropManager(props: any, ref: any) {
    const { children, dragDropManager, ...rest } = props
    return (
      <div {...rest} ref={ref}>
        {children}
      </div>
    )
  }
)

const ScrollZone = withScrolling(DivWithoutPropagatingDragDropManager)
export const SCROLLZONE_ID = 'ScrollZone'

interface WrapperProps {
  $primaryColor: string
  $isDevelopment: boolean
  $hasOtherEnvironments?: boolean
}

export const ScrollContainer: React.FC = ({ children }) => {
  const dispatch = useDispatch()
  const currentBotMetadata = useSelector(currentBotMetadataSelector)
  const metadataForCurrentEnvGroup = useSelector(
    botMetadataForEnvironmentGroupSelector(currentBotMetadata?.environmentGroupId)
  )

  const primaryColor = useBotPrimaryColor()

  useUpdateScrollbarPresenceFlag()

  const [showOverlay, setShowOverlay] = useState<ShowOverlayProps>({
    showOverlay: false,
    onOverlayClick: () => {}
  })

  return (
    <Wrapper
      $primaryColor={primaryColor}
      $isDevelopment={currentBotMetadata?.environmentType === 'test'}
      $hasOtherEnvironments={metadataForCurrentEnvGroup.length > 1}
    >
      <ScrollZone
        id={SCROLLZONE_ID}
        onScroll={() => {
          let scroll = getScrollContainerElement()?.scrollTop
          if (scroll === undefined) {
            return
          }
          dispatch(scrollAction.setOffsetTop(scroll))
        }}
      >
        <ScrollPositionContext.Provider
          value={{
            setShowOverlay,
            showOverlay
          }}
        >
          {children}
        </ScrollPositionContext.Provider>
      </ScrollZone>
    </Wrapper>
  )
}

const Wrapper = styled.div<WrapperProps>`
  background-color: ${({ $primaryColor }) => ($primaryColor ? `${$primaryColor}10` : 'none')};

  ${({ $isDevelopment, $hasOtherEnvironments }) =>
    $hasOtherEnvironments
      ? $isDevelopment
        ? 'border: 2px solid rgba(135, 140, 156, 0.8)'
        : 'border: 2px solid rgba(224, 123, 29, 0.8)'
      : ''};
  height: 100%;
`
